import React from "react";

const CloseIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.73483 2.73483C2.88128 2.58839 3.11872 2.58839 3.26517 2.73483L6 5.46967L8.73484 2.73483C8.88128 2.58839 9.11872 2.58839 9.26517 2.73483C9.41161 2.88128 9.41161 3.11872 9.26517 3.26517L6.53033 6L9.26517 8.73484C9.41161 8.88128 9.41161 9.11872 9.26517 9.26517C9.11872 9.41161 8.88128 9.41161 8.73484 9.26517L6 6.53033L3.26517 9.26517C3.11872 9.41161 2.88128 9.41161 2.73483 9.26517C2.58839 9.11872 2.58839 8.88128 2.73483 8.73484L5.46967 6L2.73483 3.26517C2.58839 3.11872 2.58839 2.88128 2.73483 2.73483Z"
        fill="#2B244C"
      />
    </svg>
  );
};

export default CloseIcon;
